enum FormType {
  POST_APPOINTMENT = 'post-appointment-form',
}

export { FormType }
